import { render, staticRenderFns } from "./NavigationDialog.vue?vue&type=template&id=530ed7db&scoped=true"
import script from "./NavigationDialog.vue?vue&type=script&lang=js"
export * from "./NavigationDialog.vue?vue&type=script&lang=js"
import style0 from "./NavigationDialog.vue?vue&type=style&index=0&id=530ed7db&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530ed7db",
  null
  
)

export default component.exports